import { useContext } from 'react'

import { SignatureFormContext } from '../context'

export function useCategory() {
  const {
    categories,
    loadingCategories: loading,
    listCategories
  } = useContext(SignatureFormContext)

  return {
    categories,
    loading,
    listCategories
  }
}
